module.exports = __webpack_public_path__ + "static/media/es-ct.3eb3a35a.svg";